module.exports = __webpack_public_path__ + "img/slider_about_small_2.80340757.png";